// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:768px){.infinite-load-more__button{width:auto;margin-left:auto;margin-right:auto;padding:11px 60px 13px}}", ""]);
// Exports
module.exports = exports;
